import { render } from "./EmergenciaView.vue?vue&type=template&id=286badc6"
import script from "./EmergenciaView.vue?vue&type=script&lang=js"
export * from "./EmergenciaView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__